import { AggregateBase } from "csi/action/AggregateBase";
import comm from "csi/comm";
import Request from "csi/def/Request";
import locale from "csi/locale";
import csi from "csi/main";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import lang from  "dojo/_base/lang";
import NewBOMLineItem from "../NewBOMLineItem";

const MODULE = "FormulatedProduct";
const NEW_RECIPE_LINE_ITEM = "RecipeNewRecipeLineItem";
const NEW_RECIPE_LINE_ITEM_FROM_FOOD = "RecipeNewRecipeLineItemFromFood";
const NEW_RECIPE_LINE_ITEM_FROM_FORMULATED_MATERIAL = "RecipeNewRecipeLineItemFromFormulatedMaterial";
const PRODUCT_TYPE_FIELD = locale.resource("ProductType");
const AGGREGATE_FORMULATED_MATERIAL_PAGE = 1;
const AGGREGATE_FOOD_PAGE = 2;

const NewRecipeLineItem = declare([NewBOMLineItem], {

	/**
	 * @override
	 * Use return value as parameter to success message based on action type
	 */
	getStringParameters() {
		const fd = this.m_formData;
		const nodes = fd.getSelectedNodes();
		return (nodes?.length) ? [`${nodes.length} ${locale.typePlural("RecipeLineItem")}`] : [locale.type("RecipeLineItem")];
	},

	/**
	 * @override
	 * Pass form data to the next page
	 */
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		const index = wizard.getIndexOfPage(nextPage);
		const fd = this.m_formData;
		if (index === 0) {
			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (index >= 1));
		}
		const itemProductTypeEnum = fd.getFieldValue(PRODUCT_TYPE_FIELD);
		
		const productType = xml.enumGetText(itemProductTypeEnum);
		if (index == AGGREGATE_FORMULATED_MATERIAL_PAGE && productType != "FormulatedMaterial") {
			return wizard.skipToNextPage(nextPage);
		} else if (index == AGGREGATE_FOOD_PAGE && productType != "Food") {
			return wizard.skipToNextPage(nextPage);
		}

		return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (index >= 1));
	},

	/**
	 * @override
	 *
	 * Conditionally create request to send to Server Operations,
	 * depending on selections made on RecipeItem wizard
	 */
	toWriter() {
		let request;
		let action;

		const fd = this.m_formData;
		const selectedProducts = fd.getSelectedNodes();
		this.m_urlNode = null; // reset in the case that "Save and New" action on wizard is selected
		const itemProductTypeEnum = fd.getFieldValue(PRODUCT_TYPE_FIELD);
		
		if (selectedProducts.length) {
			action = this.getAction() as AggregateBase;
			// Product selection was made on second page of wizard, aggregate action
			const productType = xml.enumGetText(itemProductTypeEnum);
			if (productType === "Food") {
				request = lang.mixin(new Request(), {
					m_module: MODULE,
					m_operation: NEW_RECIPE_LINE_ITEM_FROM_FOOD,
				});
			} else if (productType === "FormulatedMaterial") {
				request = lang.mixin(new Request(), {
					m_module: MODULE,
					m_operation: NEW_RECIPE_LINE_ITEM_FROM_FORMULATED_MATERIAL,
				});
			}
			
			// Set so that action can be processed as aggregate
			action.aggregateId = "Items";
			action.aggregateClass = "RecipeLineItem";

			action.m_request = request;
			this._processFormData(fd);
		} else {
			// No Product selection was made, create blank RecipeLineItem
			action = this.getAction();

			request = lang.mixin(new Request(), {
				m_module: MODULE,
				m_operation: NEW_RECIPE_LINE_ITEM,
			});

			action.m_request = request;
			request = this.setNewOperationRequest(action, request, itemProductTypeEnum);
		}
		
		return request;
	},
});

export = NewRecipeLineItem;